module.exports = __webpack_public_path__ + "img/Magnuss23.9801cb4f.jpg";